// extracted by mini-css-extract-plugin
export default {"modalTitle":"styles_modalTitle__0l4FR","successContainer":"styles_successContainer__murdi","text":"styles_text__X7oFG"};